/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../common";
import type { GmxV2Adapter, GmxV2AdapterInterface } from "../GmxV2Adapter";

const _abi = [
  {
    type: "function",
    name: "afterOrderFrozen",
    inputs: [
      {
        name: "key",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "",
        type: "tuple",
        internalType: "struct IOrder.Props",
        components: [
          {
            name: "addresses",
            type: "tuple",
            internalType: "struct IOrder.Addresses",
            components: [
              {
                name: "account",
                type: "address",
                internalType: "address",
              },
              {
                name: "receiver",
                type: "address",
                internalType: "address",
              },
              {
                name: "cancellationReceiver",
                type: "address",
                internalType: "address",
              },
              {
                name: "callbackContract",
                type: "address",
                internalType: "address",
              },
              {
                name: "uiFeeReceiver",
                type: "address",
                internalType: "address",
              },
              {
                name: "market",
                type: "address",
                internalType: "address",
              },
              {
                name: "initialCollateralToken",
                type: "address",
                internalType: "address",
              },
              {
                name: "swapPath",
                type: "address[]",
                internalType: "address[]",
              },
            ],
          },
          {
            name: "numbers",
            type: "tuple",
            internalType: "struct IOrder.Numbers",
            components: [
              {
                name: "orderType",
                type: "uint8",
                internalType: "enum IOrder.OrderType",
              },
              {
                name: "decreasePositionSwapType",
                type: "uint8",
                internalType: "enum IOrder.DecreasePositionSwapType",
              },
              {
                name: "sizeDeltaUsd",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "initialCollateralDeltaAmount",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "triggerPrice",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "acceptablePrice",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "executionFee",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "callbackGasLimit",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "minOutputAmount",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "updatedAtBlock",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "updatedAtTime",
                type: "uint256",
                internalType: "uint256",
              },
            ],
          },
          {
            name: "flags",
            type: "tuple",
            internalType: "struct IOrder.Flags",
            components: [
              {
                name: "isLong",
                type: "bool",
                internalType: "bool",
              },
              {
                name: "shouldUnwrapNativeToken",
                type: "bool",
                internalType: "bool",
              },
              {
                name: "isFrozen",
                type: "bool",
                internalType: "bool",
              },
              {
                name: "autoCancel",
                type: "bool",
                internalType: "bool",
              },
            ],
          },
        ],
      },
      {
        name: "",
        type: "tuple",
        internalType: "struct IEvent.EventLogData",
        components: [
          {
            name: "addressItems",
            type: "tuple",
            internalType: "struct IEvent.AddressItems",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.AddressKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "address",
                    internalType: "address",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.AddressArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "address[]",
                    internalType: "address[]",
                  },
                ],
              },
            ],
          },
          {
            name: "uintItems",
            type: "tuple",
            internalType: "struct IEvent.UintItems",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.UintKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "uint256",
                    internalType: "uint256",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.UintArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "uint256[]",
                    internalType: "uint256[]",
                  },
                ],
              },
            ],
          },
          {
            name: "intItems",
            type: "tuple",
            internalType: "struct IEvent.IntItems",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.IntKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "int256",
                    internalType: "int256",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.IntArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "int256[]",
                    internalType: "int256[]",
                  },
                ],
              },
            ],
          },
          {
            name: "boolItems",
            type: "tuple",
            internalType: "struct IEvent.BoolItems",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.BoolKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "bool",
                    internalType: "bool",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.BoolArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "bool[]",
                    internalType: "bool[]",
                  },
                ],
              },
            ],
          },
          {
            name: "bytes32Items",
            type: "tuple",
            internalType: "struct IEvent.Bytes32Items",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.Bytes32KeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "bytes32",
                    internalType: "bytes32",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.Bytes32ArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "bytes32[]",
                    internalType: "bytes32[]",
                  },
                ],
              },
            ],
          },
          {
            name: "bytesItems",
            type: "tuple",
            internalType: "struct IEvent.BytesItems",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.BytesKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "bytes",
                    internalType: "bytes",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.BytesArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "bytes[]",
                    internalType: "bytes[]",
                  },
                ],
              },
            ],
          },
          {
            name: "stringItems",
            type: "tuple",
            internalType: "struct IEvent.StringItems",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.StringKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "string",
                    internalType: "string",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.StringArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "string[]",
                    internalType: "string[]",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "cancelExpiredOrder",
    inputs: [
      {
        name: "key",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "cancelOrder",
    inputs: [
      {
        name: "key",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "claimFundingFees",
    inputs: [
      {
        name: "markets",
        type: "address[]",
        internalType: "address[]",
      },
      {
        name: "tokens",
        type: "address[]",
        internalType: "address[]",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256[]",
        internalType: "uint256[]",
      },
    ],
    stateMutability: "payable",
  },
  {
    type: "function",
    name: "claimNativeToken",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "claimToken",
    inputs: [
      {
        name: "token",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "closePosition",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "getPositionKey",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "initialize",
    inputs: [
      {
        name: "projectId_",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "liquidityPool",
        type: "address",
        internalType: "address",
      },
      {
        name: "owner",
        type: "address",
        internalType: "address",
      },
      {
        name: "collateralToken",
        type: "address",
        internalType: "address",
      },
      {
        name: "market",
        type: "address",
        internalType: "address",
      },
      {
        name: "isLong",
        type: "bool",
        internalType: "bool",
      },
      {
        name: "markets",
        type: "address[]",
        internalType: "address[]",
      },
      {
        name: "paths",
        type: "address[][]",
        internalType: "address[][]",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "placeOrder",
    inputs: [
      {
        name: "createParams",
        type: "tuple",
        internalType: "struct IGmxV2Adapter.OrderCreateParams",
        components: [
          {
            name: "swapPath",
            type: "address[]",
            internalType: "address[]",
          },
          {
            name: "initialCollateralAmount",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "tokenOutMinAmount",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "borrowCollateralAmount",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "sizeDeltaUsd",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "triggerPrice",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "acceptablePrice",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "executionFee",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "callbackGasLimit",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "orderType",
            type: "uint8",
            internalType: "enum IOrder.OrderType",
          },
        ],
      },
    ],
    outputs: [
      {
        name: "",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    stateMutability: "payable",
  },
  {
    type: "function",
    name: "updateOrder",
    inputs: [
      {
        name: "key",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "sizeDeltaUsd",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "acceptablePrice",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "triggerPrice",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "viewStorage",
    inputs: [],
    outputs: [
      {
        name: "collateralDeposited",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "realizedPnL",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "event",
    name: "Initialized",
    inputs: [
      {
        name: "version",
        type: "uint8",
        indexed: false,
        internalType: "uint8",
      },
    ],
    anonymous: false,
  },
] as const;

const _bytecode =
  "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$62d090cdb3f00c58d8fc9cefd4ad1697bb$__5af490811561189a5790611863575b602090604051908152f35b506020813d8211611892575b8161187c60209383612c01565b8101031261188d5760209051611858565b600080fd5b3d915061186f565b604051903d90823e3d90fd5b82346100da5760803660031901126100da576118c361181461376c565b6118d260ff602d541615612e50565b6118da6134c9565b6118e2613799565b8073__$62d090cdb3f00c58d8fc9cefd4ad1697bb$__803b1561196f578160a491604051928380926333691f0360e21b825284600483015260043560248301526024356044830152604435606483015260643560848301525af4801561196457611950575b50600160a45580f35b61195990612bb8565b6100da578082611947565b6040513d84823e3d90fd5b50fd5b82600319916020833601126117ec57600435906001600160401b038083116117d257610140809584360301126117d257604051948501858110828211176117d65760405282600401359081116117d257906119d7610124939260043691850101612c4d565b85526024820135602086015260448201356040860152606482013560608601526084820135608086015260a482013560a086015260c482013560c086015260e48201359085015261010481013561010085015201359060088210156100da576020611a6a8484610120820152611a4e61181461376c565b611a5d60ff602d541615612e50565b611a656134c9565b612f86565b600160a455604051908152f35b82346100da5760203660031901126100da57611a9461181461376c565b611aa360ff602d541615612e50565b611aab6134c9565b611ab3613799565b8073__$62d090cdb3f00c58d8fc9cefd4ad1697bb$__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__$62d090cdb3f00c58d8fc9cefd4ad1697bb$__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__$62d090cdb3f00c58d8fc9cefd4ad1697bb$__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";

type GmxV2AdapterConstructorParams =
  | [linkLibraryAddresses: GmxV2AdapterLibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GmxV2AdapterConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === "string" ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    "_isInterface" in xs[0]
  );
};

export class GmxV2Adapter__factory extends ContractFactory {
  constructor(...args: GmxV2AdapterConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      const [linkLibraryAddresses, signer] = args;
      super(
        _abi,
        GmxV2Adapter__factory.linkBytecode(linkLibraryAddresses),
        signer
      );
    }
  }

  static linkBytecode(
    linkLibraryAddresses: GmxV2AdapterLibraryAddresses
  ): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$62d090cdb3f00c58d8fc9cefd4ad1697bb\\$__", "g"),
      linkLibraryAddresses[
        "src/aggregators/gmxV2/libraries/LibGmxV2.sol:LibGmxV2"
      ]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    return linkedBytecode;
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      GmxV2Adapter & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): GmxV2Adapter__factory {
    return super.connect(runner) as GmxV2Adapter__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GmxV2AdapterInterface {
    return new Interface(_abi) as GmxV2AdapterInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): GmxV2Adapter {
    return new Contract(address, _abi, runner) as unknown as GmxV2Adapter;
  }
}

export interface GmxV2AdapterLibraryAddresses {
  ["src/aggregators/gmxV2/libraries/LibGmxV2.sol:LibGmxV2"]: string;
}
